module.exports = __webpack_public_path__ + "static/media/spectator-icon.be73d9ef.png";